module.exports = __webpack_public_path__ + "img/bca.5ad5d3ea.png";